import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, offset = 0, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/warnings/?offset=${offset}&size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/warnings/${id}/`,
			headers.bearer()
		)
	},
	update (context, user_uid, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/warnings/${model.id}/`,
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/warnings.js